export default class BranchConfiguration {
	constructor(
        public companyId: number,
        public databaseAlias: string,
	) { }

	static make(data: any): BranchConfiguration {
		return new BranchConfiguration(
            data.company_id,
            data.database_alias,
		);
	}
}
